<template>
  <div 
    :class="baseStackClasses" 
    class="base-stack"
  >
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  noWrap: {
    type: Boolean,
    default: false,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
  direction: {
    type: String,
    default: "horizontal",
    validator: (value) => ["horizontal", "vertical"].includes(value),
  },
  spacing: {
    type: String,
    default: "",
    validator: (value) => [
      "",
      "none",
      "x-tight",
      "slim",
      "regular",
      "tight",
      "loose",
      "x-loose",
    ].includes(value),
  },
  distribution: {
    type: String,
    default: "",
    validator: (value) => [
      "",
      "leading",
      "trailing",
      "center",
      "equal-spacing",
      "fill",
      "fill-evenly",
    ].includes(value),
  },
  alignment: {
    type: String,
    default: "",
    validator: (value) => [
      "",
      "leading",
      "trailing",
      "center",
      "fill",
      "baseline",
    ].includes(value),
  },
});

const baseStackClasses = computed(() => ({
  "base-stack--no-wrap": props.noWrap,
  "base-stack--is-full-width": props.isFullWidth,
  [`base-stack--direction-${props.direction}`]: true,
  [`base-stack--spacing-${props.spacing}`]: true,
  [`base-stack--distribution-${props.distribution}`]: true,
  [`base-stack--alignment-${props.alignment}`]: true,
}));
</script>

<style lang="scss">
@import "./base-stack.scss";
</style>
